import React, { Component } from 'react';

import moment from 'moment';

import WorkspaceCard from './WorkspaceCard';
import WorkspaceCardErrors from './WorkspaceCardErrors';

export default class WorkspaceCenter extends Component {

	constructor(props) {
		super(props);

		this.state = {
			activeRowMenu: null,
			isDragging: false,
			dragRowCurrent: null,
			dragId: null
		}

		this.rem = parseFloat(getComputedStyle(document.documentElement).fontSize)
		this.dragY1 = 0;
		this.dragY2 = 0;
		this.dragScrollTop1 = 0
		this.dragRowCurrent = 0

		this.setActiveRowMenu = this.setActiveRowMenu.bind(this);

		this.saveWorkspace = this.saveWorkspace.bind(this);
		this.handleTitleInput = this.handleTitleInput.bind(this)
		this.handleDescriptionInput = this.handleDescriptionInput.bind(this);

		this.toggleRows = this.toggleRows.bind(this);
		this.deleteRow = this.deleteRow.bind(this);
		this.addRow = this.addRow.bind(this);

		this.isCoordinateAvailable = this.isCoordinateAvailable.bind(this);
		this.isStretchAvailable = this.isStretchAvailable.bind(this);
		this.stretchUp = this.stretchUp.bind(this);
		this.stretchRight = this.stretchRight.bind(this);
		this.stretchDown = this.stretchDown.bind(this);
		this.stretchLeft = this.stretchLeft.bind(this);
		this.shrinkUp = this.shrinkUp.bind(this);
		this.shrinkRight = this.shrinkRight.bind(this);
		this.shrinkDown = this.shrinkDown.bind(this);
		this.shrinkLeft = this.shrinkLeft.bind(this);
		this.moveUp = this.moveUp.bind(this);
		this.moveRight = this.moveRight.bind(this);
		this.moveDown = this.moveDown.bind(this);
		this.moveLeft = this.moveLeft.bind(this);
		this.findNearestCard = this.findNearestCard.bind(this);


		this.beginDrag = this.beginDrag.bind(this);
		this.doDrag = this.doDrag.bind(this);
		this.endDrag = this.endDrag.bind(this);

		this.generateMetaData = this.generateMetaData.bind(this);
		this.generateDesignView = this.generateDesignView.bind(this);
		this.generateCards = this.generateCards.bind(this);
		this.generateWorkspaceInProgressView = this.generateWorkspaceInProgressView.bind(this);
		this.generateSelectWorkspaceView = this.generateSelectWorkspaceView.bind(this);
		this.setFavorite = this.setFavorite.bind(this);

	}

	setActiveRowMenu(menu) {
		this.setState({ activeRowMenu: menu })
	}

	saveWorkspace() {
		let workspace = this.props.workspace;
		workspace.details.lastSaved = moment().format("MM/DD/YYYY h:mm a z");
		if (workspace != null) {
			this.props.saveWorkspace(this.props.workspace, () => { })
		}
	}

	handleTitleInput(e) {
		let value = e.target.value;
		value = value.substring(0, 40);

		let workspace = this.props.workspace;
		if (workspace != null) {
			workspace.details.name = value
			workspace.title = value

			this.props.modifyWorkspaceNoSave('name', workspace.details.name, () => { })
		}
	}

	handleDescriptionInput(e) {
		if (!this.props.isDesignMode) {
			e.preventDefault();
		} else {
			let value = e.target.value;
			value = value.substring(0, 120);

			let workspace = this.props.workspace;
			if (workspace != null) {
				workspace.details.description = value

				this.props.modifyWorkspaceNoSave('name', workspace.details.name, () => { })
			}
		}

	}

	toggleRows(y) {
		let workspace = this.props.workspace;
		if (workspace != null) {

			if (workspace.details.rows[y].columns === 4 &&
				workspace.details.rows[y].cards[3] != undefined &&
				workspace.details.rows[y].cards[3] != null) {

				zconfirm("Are you sure you want to switch this row to a 3-chart format? " +
					"Doing so will delete the rightmost visual in this row. (This cannot be undone.)", () => {
						workspace.details.rows[y].columns = workspace.details.rows[y].columns === 4 ? 3 : 4;
						workspace.details.rows[y].cards.splice(3, 1);
						this.props.modifyWorkspace('rows', workspace.details.rows, () => { })
					})
			} else {
				if (workspace.details.rows[y].columns === 4) {
					workspace.details.rows[y].cards.splice(3, 1);

					workspace.details.rows[y].cards.forEach((card, index) => {
						if (card != null && card.width + index >= 4) {
							card.width--;
						}
					})
				} else if (workspace.details.rows[y].cards.length != 4) {
					for (var i = workspace.details.rows[y].cards.length; i < 4; i++) {
						workspace.details.rows[y].cards.push(null);
					}
				}

				workspace.details.rows[y].columns = workspace.details.rows[y].columns === 4 ? 3 : 4;
				this.props.modifyWorkspace('rows', workspace.details.rows, () => { })
			}
		}
	}

	deleteRow(y) {
		let workspace = this.props.workspace;
		if (workspace != null && workspace.details.rows.length > 1) {
			let rows = workspace.details.rows;

			// workspace.rowRenderOrder.splice(workspace.rowRenderOrder.indexOf(rows[y].id), 1); // Don't delete. Do null check instead. Can be reverted.
			rows.splice(y, 1);

			this.props.modifyWorkspace('rows', rows, () => { this.setState({ activeRowMenu: null }) })
		}
	}

	addRow(y) {
		let workspace = this.props.workspace;
		if (workspace != null) {
			let rows = workspace.details.rows;

			let tmpRowId = this.props.createRowId();
			rows.splice(y + 1, 0, {
				rowId: tmpRowId,
				cards: [],
				columns: rows[y].columns
			})

			workspace.rowRenderOrder.push(tmpRowId)

			this.props.modifyWorkspace('rows', rows, () => { this.setState({ activeRowMenu: null }) })
		}
	}

	isCoordinateAvailable(x, y, columns) {
		let details = this.props.workspace.details;

		if (details.rows[y] === undefined || details.rows[y] === null) {
			return false;
		}

		if (details.rows[y].columns != columns) {
			return false;
		}

		if (details.rows[y].cards.length === 0) {
			for (var i = 0; i < details.rows[y].columns; i++) {
				details.rows[y].cards.push(null);
			}
		}

		if (details.rows[y].cards[x] === undefined || details.rows[y].cards[x] != null) {
			return false;
		}

		let gridView = [];
		details.rows.forEach((row, ty) => {
			gridView.push([]);
			row.cards.forEach((card, tx) => {
				gridView[ty].push(0)
			})
		});
		details.rows.forEach((row, ty) => {
			if (row.columns != columns) {
				row.cards.forEach((card, tx) => {
					gridView[ty].push(1);
				})
			} else {
				row.cards.forEach((card, tx) => {
					if (card != null) {
						for (var ny = ty; ny < ty + card.height; ny++) {
							for (var nx = tx; nx < tx + card.width; nx++) {
								if (gridView != undefined && gridView[ny] != undefined) {
									gridView[ny][nx] = 1
								}
							}
						}
					}
				})
			}
		})
		if (gridView[y][x]) {
			return false;
		}

		return true;
	}

	isStretchAvailable(x, y, width, height, columns) {
		let details = this.props.workspace.details;

		for (var ny = y; ny < y + height; ny++) {
			for (var nx = x; nx < x + width; nx++) {
				if (!this.isCoordinateAvailable(nx, ny, columns)) {
					return false;
				}
			}
		}

		return true;
	}

	stretchUp(x, y, card) {
		card.height += 1
		this.props.workspace.details.rows[y - 1].cards[x] = card;
		this.props.workspace.details.rows[y].cards[x] = null;
		this.forceUpdate();
		this.props.saveWorkspace(this.props.workspace);
	}

	stretchRight(x, y, card) {
		card.width += 1
		this.forceUpdate();
		this.props.saveWorkspace(this.props.workspace);
	}

	stretchDown(x, y, card) {
		card.height += 1
		this.forceUpdate();
		this.props.saveWorkspace(this.props.workspace);
	}

	stretchLeft(x, y, card) {
		card.width += 1;
		this.props.workspace.details.rows[y].cards[x - 1] = card;
		this.props.workspace.details.rows[y].cards[x] = null;
		this.forceUpdate();
		this.props.saveWorkspace(this.props.workspace);
	}

	shrinkUp(x, y, card) {
		card.height -= 1
		this.forceUpdate();
		this.props.saveWorkspace(this.props.workspace);
	}

	shrinkRight(x, y, card) {
		card.width -= 1;
		this.props.workspace.details.rows[y].cards[x + 1] = card;
		this.props.workspace.details.rows[y].cards[x] = null;
		this.forceUpdate();
		this.props.saveWorkspace(this.props.workspace);
	}

	shrinkDown(x, y, card) {
		card.height -= 1
		this.props.workspace.details.rows[y + 1].cards[x] = card;
		this.props.workspace.details.rows[y].cards[x] = null;
		this.forceUpdate();
		this.props.saveWorkspace(this.props.workspace);
	}

	shrinkLeft(x, y, card) {
		card.width -= 1;
		this.forceUpdate();
		this.props.saveWorkspace(this.props.workspace);
	}

	moveUp(x, y, card) {
		this.props.workspace.details.rows[y - 1].cards[x] = card;
		this.props.workspace.details.rows[y].cards[x] = null;
		this.forceUpdate();
		this.props.saveWorkspace(this.props.workspace);
	}

	moveRight(x, y, card) {
		this.props.workspace.details.rows[y].cards[x + 1] = card;
		this.props.workspace.details.rows[y].cards[x] = null;
		this.forceUpdate();
		this.props.saveWorkspace(this.props.workspace);
	}

	moveDown(x, y, card) {
		this.props.workspace.details.rows[y + 1].cards[x] = card;
		this.props.workspace.details.rows[y].cards[x] = null;
		this.forceUpdate();
		this.props.saveWorkspace(this.props.workspace);
	}

	moveLeft(x, y, card) {
		this.props.workspace.details.rows[y].cards[x - 1] = card;
		this.props.workspace.details.rows[y].cards[x] = null;
		this.forceUpdate();
		this.props.saveWorkspace(this.props.workspace);
	}

	findNearestCard(x, y, direction) {
		let details = this.props.workspace.details;

		let path = [];
		let pathCoords = [];

		let gridView = [];
		details.rows.forEach((row, ty) => {
			gridView.push([]);
			path.push([]);
			row.cards.forEach((card, tx) => {
				gridView[ty].push(null)
				path[ty].push(null);
			})
		});
		details.rows.forEach((row, ty) => {
			row.cards.forEach((card, tx) => {
				if (card != null) {
					if (ty === y && tx === x) {
						gridView[ty][tx] = null;
						path[ty][tx] = "S";
					} else {
						for (var ny = ty; ny < ty + card.height; ny++) {
							for (var nx = tx; nx < tx + card.width; nx++) {
								gridView[ny][nx] = card.id;
							}
						}
					}
				}
			});
		})
		console.table(gridView);

		console.table(path);
		let pathStep = 0
		let findPath = (tx, ty, order) => {
			if (path[ty] === undefined || path[ty][tx] === undefined) {
				return;
			}

			let nextOrder = [];
			order.forEach(o => {
				let nx = tx + o.dx, ny = ty + o.dy;
				if (path[ny] != undefined && path[ny][nx] === null) {
					path[ny][nx] = pathStep++;
					pathCoords.push([ny, nx]);
					nextOrder.push(o);
				}
			})
			nextOrder.forEach(o => {
				findPath(tx + o.dx, ty + o.dy, order);
			})

		}

		switch (direction) {
			case "up":
				if (path[y - 1] != undefined && path[y - 1][x] === null) {
					path[y - 1][x] = pathStep++;
					pathCoords.push([y - 1, x]);
				}
				findPath(x, y - 1, [{ dx: 0, dy: -1 }, { dx: -1, dy: 0 }, { dx: 1, dy: 0 }]);
				break;
			case "right":
				if (path[y] != undefined && path[y][x + 1] === null) {
					path[y][x + 1] = pathStep++;
					pathCoords.push([y, x + 1]);
				}
				findPath(x + 1, y, [{ dx: 1, dy: 0 }, { dx: 0, dy: 1 }, { dx: 0, dy: -1 }]);
				break;
			case "down":
				if (path[y + 1] != undefined && path[y + 1][x] === null) {
					path[y + 1][x] = pathStep++;
					pathCoords.push([y + 1, x]);
				}
				findPath(x, y + 1, [{ dx: 0, dy: 1 }, { dx: 1, dy: 0 }, { dx: -1, dy: 0 }]);
				break;
			case "left":
				if (path[y] != undefined && path[y][x - 1] === null) {
					path[y][x - 1] = pathStep++;
					pathCoords.push([y, x - 1]);
				}
				findPath(x - 1, y, [{ dx: -1, dy: 0 }, { dx: 0, dy: -1 }, { dx: 0, dy: 1 }]);
				break;
		}
		console.table(path);
		console.table(pathCoords);

		for (var i = 0; i < pathCoords.length; i++) {
			if (gridView[pathCoords[i][0]][pathCoords[i][1]] != null) {
				document.getElementById("visualization-card-id-" + gridView[pathCoords[i][0]][pathCoords[i][1]]).focus();
				break;
			}
		}
	}

	beginDrag(y, rowId, e) {
		let workspace = this.props.workspace;
		if (workspace != null) {
			let rows = workspace.details.rows;

			e = e || window.event
			e.preventDefault();

			rows.forEach((row, ny) => {
				if (row.rowId === rowId) {
					y = ny;
				}
			})

			this.rem = parseFloat(getComputedStyle(document.documentElement).fontSize)

			this.dragY1 = 0;
			this.dragY2 = e.clientY;

			this.dragScrollTop1 = document.getElementsByClassName('workspace-center-outer')[0].scrollTop;

			this.dragRowCurrent = y;

			document.onmousemove = this.doDrag.bind(null, y, rowId);
			document.onmouseup = this.endDrag;

			this.setState({ isDragging: true, dragId: y, dragRowCurrent: y })
		}
	}

	doDrag(y, rowId, e) {
		e = e || window.event
		e.preventDefault()

		this.dragY1 = this.dragY2 - e.clientY;
		this.dragY2 = e.clientY;

		let scrollDiff = (document.getElementsByClassName('workspace-center-outer')[0].scrollTop - this.dragScrollTop1) / this.rem
		this.dragScrollTop1 = document.getElementsByClassName('workspace-center-outer')[0].scrollTop

		// let el = document.getElementsByClassName('design-row')[y]
		let el = document.getElementById("workspace-row-" + rowId);

		let newTop = ((el.offsetTop - this.dragY1) / this.rem)
		newTop += scrollDiff
		if (newTop < 0) {
			newTop = 0
		}

		let drc = Math.floor((newTop + 9.75) / 19.5)
		if (drc != this.dragRowCurrent) {
			this.dragRowCurrent = drc;
			this.setState({ dragRowCurrent: drc })
		}

		el.style.top = newTop + "rem"
		el.style.zIndex = 5;
	}

	endDrag(e) {
		document.onmouseup = null;
		document.onmousemove = null;

		let workspace = this.props.workspace;
		let rows = workspace.details.rows;

		let tmpRow = rows.splice(this.state.dragId, 1)[0]
		rows.splice(this.state.dragRowCurrent, 0, tmpRow)

		this.props.modifyWorkspace('rows', rows,
			() => {
				this.setState({ isDragging: false, dragId: null, dragRowCurrent: null },
					() => {

						rows.forEach((row, i) => {
							document.getElementById("workspace-row-" + row.rowId).style.top = (i * 19.5) + "rem"
						});
					})
			})

	}

	generateMetaData() {
		let workspace = this.props.workspace;
		let isPublished = false;

		if (workspace === null || workspace === undefined) {
			return (
				<div className={"meta-data-container"}>

				</div>
			)
		}

		let publishedDetails = workspace.publishedDetails;
		let details = workspace.details;


		//TODO: Modify to not do double loop. Do some javascript dictionary magic instead
		for (let i = 0; i < publishedDetails.rows.length; i++) {
			for (let j = 0; j < publishedDetails.rows[i].cards.length; j++) {
				if (publishedDetails.rows[i].cards[j] !== null) {
					isPublished = true;
					break;
				}
			}
		}

		return (
			<div className={"meta-data-container"}>
				<input
					className={this.props.isDesignMode ? "title title-border" : "title"}
					value={!this.props.isDesignMode ? publishedDetails.name : details.name}
					onChange={this.handleTitleInput}
					onBlur={this.saveWorkspace}
					readOnly={!this.props.isDesignMode}
				/>
				<input
					className={this.props.isDesignMode ? "description description-border" : "description"}
					value={details.description}
					onChange={this.handleDescriptionInput}
					onBlur={this.saveWorkspace}
					readOnly={!this.props.isDesignMode}
				/>
				<div className={ this.props.workspace.details.favorite ? !this.props.isDesignMode ? "material-icons favorite" : "dispNone" : "dispNone"} onClick={this.setFavorite}>star</div>
				<div className={ this.props.workspace.details.favorite ? "dispNone" : !this.props.isDesignMode ? "material-icons favorite" : "dispNone" } onClick={this.setFavorite}>star_outline</div>
				<div className={this.props.isDesignMode ? "dispNone" : "draft-save top"}>{"Time Range of " + moment(window.dateIndexToDate(this.props.timeFilter.fromDate)).format("M/D/YY") + " to " + moment(window.dateIndexToDate(this.props.timeFilter.toDate)).format("M/D/YY")}</div>
				<div className={this.props.isDesignMode ? "draft-save top" : "dispNone"}>{"Draft Saved on " + moment(details.lastSaved).format("M/D/YY h:mm a")}</div>
				<div className={"draft-save bottom"}>{isPublished ? "Published on " + moment(publishedDetails.lastSaved).format("M/D/YY h:mm a") : ""}</div>
			</div>
		)
	}

	setFavorite() {
		this.props.modifyWorkspace("favorite",!this.props.workspace.details.favorite);
	}

	generateDesignView() {
		let workspace = this.props.workspace;

		if (workspace === null || workspace === undefined) {
			return (
				<div className={"design-view-outer hidden"}></div>
			)
		}

		let details = workspace.details;

		let rows = {};
		details.rows.forEach((row, y) => {

			let addBoxes = []
			for (var x = 0; x < row.columns; x++) {
				addBoxes.push((
					<div className={`add-box-outer width-${row.columns}`}>
						<div data-trackid = {'CreateCard'} className={"add-box-inner"} onClick={this.props.openNewCardModal.bind(null, y, x)}>
							<div className={"material-icons add-circle"}>{"add"}</div>
						</div>
					</div>
				))
			}

			let canDelete = details.rows.length > 1
			if (canDelete) {
				details.rows.forEach((y2, i) => {
					y2.cards.forEach((x, j) => {
						if (x != null && i <= y && i + x.height - 1 >= y) {
							canDelete = false;
						}
					})
				})
			}

			let tmpY = y;
			let transText = "top 0.35s ease-in-out";
			let zIndex = "unset";
			if (this.state.isDragging) {
				if (y === this.state.dragId) {
					transText = "unset"
					zIndex = 5;
				} else if (y > this.state.dragId) {
					if (y <= this.state.dragRowCurrent) {
						tmpY = y - 1
					}
				} else if (y < this.state.dragId) {
					if (y >= this.state.dragRowCurrent) {
						tmpY = y + 1
					}
				}
			}

			rows[row.rowId] = (
				<div
					key={"workspace-row-" + row.rowId}
					id={"workspace-row-" + row.rowId}
					className={"design-row"}
					style={{ top: (tmpY * 19.5) + "rem", transition: transText, zIndex: zIndex }}
				>
					<div className={"box-container"}>
						{addBoxes}
					</div>
					<div className={"options-container" + (this.state.activeRowMenu === y ? " menu-active" : "")}>
						<div className={"material-icons options-button"} onClick={this.setActiveRowMenu.bind(null, y)}>{"more_vert"}</div>
						<div className={"material-icons options-dragger" + (this.state.isDragging ? " dragging" : "")} onMouseDown={this.beginDrag.bind(null, y, row.rowId)}>{"drag_indicator"}</div>
						<div className={"options-accent-1"}></div>
						<div className={"options-accent-2"}></div>
						<div className={"back-blocker"} onClick={this.setActiveRowMenu.bind(null, null)}></div>
						<div className={"menu"}>
							<div className={"option"} onClick={this.addRow.bind(null, y)}>{"Add"}</div>
							<div className={"option" + (canDelete ? "" : " disabled")} onClick={canDelete ? this.deleteRow.bind(null, y) : null}>{"Delete"}</div>
							<div className={"option"} onClick={this.toggleRows.bind(null, y)}>
								<div className={"switch-text"}>{"4-chart layout"}</div>
								<div className={"switch" + (row.columns === 4 ? " active" : "")}>
									<div className={"knob"}></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		})

		let rowsJsx = [];
		workspace.rowRenderOrder.forEach(key => {
			if (rows[key] != null && rows[key] != undefined) {
				rowsJsx.push(rows[key]);
			}
		})

		return (
			<div className={"design-view-outer" + (this.props.isDesignMode ? "" : " hidden")} style={{ height: (details.rows.length * 19.5) + "rem" }}>
				{rowsJsx}
			</div>
		)
	}

	generateCards() {

		let workspace = this.props.workspace;

		if (workspace === null || workspace === undefined) {
			return (
				<div className={"card-view-outer"}></div>
			)
		}

		let details = this.props.isDesignMode ? workspace.details : workspace.publishedDetails;
		let isAABIDash;
		if(details.isAABIDash !== undefined) {
			isAABIDash = true;
		} else {
			isAABIDash = false;
		}
		let cardsJsx = {}
		details.rows.forEach((row, y) => {
			let columns = row.columns;
			row.cards.forEach((card, x) => {
				if (card != null) {

					cardsJsx[card.id] = (
						<WorkspaceCardErrors x={x} y={y} columns={columns} height={card.height} width={card.width}>
						<WorkspaceCard
							isDesignMode={this.props.isDesignMode}
							identity={card}
							columns={columns}
							x={x}
							y={y}
							menuOpen={card.id === this.props.visualizationOpenMenuId}
							allData={this.props.allData}
							longData={this.props.longData}
							allMaps={this.props.allMaps}
							defaultGroupings={this.props.defaultGroupings}
							defaultKpiOrder={this.props.defaultKpiOrder}
							defaultFilters={this.props.defaultFilters}
							workspaceFilters={this.props.workspaceFilters}
							fullscreenId={this.props.fullscreenId}
							metricDefinitions={this.props.metricDefinitions}
							metricDefs={this.props.metricDefs}
							timeFilter={this.props.timeFilter}
							canShrinkX={card.width > 1}
							canShrinkY={card.height > 1}
							canStretchUp={this.isStretchAvailable(x, y - 1, card.width, 1, columns)}
							canStretchRight={this.isStretchAvailable(x + card.width, y, 1, card.height, columns)}
							canStretchDown={this.isStretchAvailable(x, y + card.height, card.width, 1, columns)}
							canStretchLeft={this.isStretchAvailable(x - 1, y, 1, card.height, columns)}

							openModal={this.props.openModal}
							openEditCardModal={this.props.openEditCardModal}

							openFullscreen={this.props.openFullscreen}
							closeFullscreen={this.props.closeFullscreen}

							toggleChart={this.props.toggleChart}
							deleteVisual={this.props.deleteVisual}
							openMenu={this.props.openVisualizationMenu}
							closeMenu={this.props.closeVisualizationMenu}
							dataLoading={this.props.dataLoading}
							longDataLoading={this.props.longDataLoading}
							cardLoading={this.props.cardLoading}
							toggleLock={this.props.toggleLock}
							isAABIDash={isAABIDash}

							stretchUp={this.stretchUp.bind(null, x, y, card)}
							stretchRight={this.stretchRight.bind(null, x, y, card)}
							stretchDown={this.stretchDown.bind(null, x, y, card)}
							stretchLeft={this.stretchLeft.bind(null, x, y, card)}
							shrinkUp={this.shrinkUp.bind(null, x, y, card)}
							shrinkRight={this.shrinkRight.bind(null, x, y, card)}
							shrinkDown={this.shrinkDown.bind(null, x, y, card)}
							shrinkLeft={this.shrinkLeft.bind(null, x, y, card)}
							moveUp={this.moveUp.bind(null, x, y, card)}
							moveRight={this.moveRight.bind(null, x, y, card)}
							moveDown={this.moveDown.bind(null, x, y, card)}
							moveLeft={this.moveLeft.bind(null, x, y, card)}
							switchUp={this.findNearestCard.bind(null, x, y, "up")}
							switchRight={this.findNearestCard.bind(null, x, y, "right")}
							switchDown={this.findNearestCard.bind(null, x, y, "down")}
							switchLeft={this.findNearestCard.bind(null, x, y, "left")}
						/></WorkspaceCardErrors>
					)
				}
			})
		})

		let cardsRenderJsx = []
		workspace.cardRenderOrder.forEach(key => {
			if (cardsJsx[key] != undefined && cardsJsx[key] != null) {
				cardsRenderJsx.push(cardsJsx[key]);
			}
		})

		return (
			<div className={"card-view-outer"}>
				<div className={"card-container"}>
					{cardsRenderJsx}
				</div>
			</div>
		)
	}

	generateWorkspaceInProgressView() {

		let workspace = this.props.workspace;

		let generateInProgressView = true;

		if (workspace === undefined || workspace === null || this.props.isDesignMode) {
			return (
				null
			)
		}

		let details = this.props.isDesignMode ? workspace.details : workspace.publishedDetails;

		//TODO: Modify to not do double loop. Do some javascript dictionary magic instead
		for (let i = 0; i < details.rows.length; i++) {
			for (let j = 0; j < details.rows[i].cards.length; j++) {
				if (details.rows[i].cards[j] !== null) {
					generateInProgressView = false;
					break;
				}
			}
		}

		if (generateInProgressView) {
			return (
				<div className={"workspace-in-progress-container"}>
					<div className={"workspace-in-progress"}>
						Dashboard in Progress
					</div>
					<i className="material-icons icon-positioning">{"square_foot"}</i>
				</div>

			);
		} else {
			return null;
		}
	}

	generateSelectWorkspaceView() {
		let workspace = this.props.workspace;

		if (workspace === undefined || workspace === null) {
			return (
				<div className={"workspace-in-progress-container"}>
					<div className={"workspace-in-progress"}>
						Select a Dashboard
					</div>
					<i className="material-icons icon-positioning">{"dashboard"}</i>
				</div>
			)
		} else {
			return null;
		}
	}

	render() {

		let workspace = this.props.workspace;

		return (
			<div id={"workspace-center-outer"} className={"workspace-center-outer" + (this.props.isDesignMode ? " design" : "")}>
				<div id={"workspace-center-scroll-fill"} className={"workspace-center-scroll-fill"}>
					{this.generateMetaData()}
					{this.generateDesignView()}
					{this.generateCards()}
					{this.generateWorkspaceInProgressView()}
					{this.generateSelectWorkspaceView()}
					<div
						className={"fullscreen-shadow" + (this.props.fullscreenId === null ? " hidden" : "")}
						onClick={this.props.closeFullscreen}
					></div>
				</div>
			</div>
		);
	}
}